import { render, staticRenderFns } from "./PopUpload.vue?vue&type=template&id=f64b3fdc&scoped=true&"
import script from "./PopUpload.vue?vue&type=script&lang=js&"
export * from "./PopUpload.vue?vue&type=script&lang=js&"
import style0 from "./PopUpload.vue?vue&type=style&index=0&id=f64b3fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b3fdc",
  null
  
)

export default component.exports